import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  PARTNERS_ADD_PATH,
  PARTNERS_PATH,
  PARTNERS_UPDATE_PATH,
} from "utils/constants/paths";

const Partners = Loadable(React.lazy(() => import("./View")));
const PartnersAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate"))
);

export const PartnersRoute: IRouteItem = {
  path: PARTNERS_PATH,
  iconName: "ShopAdd",
  element: React.createElement(Partners),
  name: "Partners",
  accessKeys: ["ContentCreator"],
  children: [
    {
      name: "Add / Update",
      path: PARTNERS_ADD_PATH,
      element: React.createElement(PartnersAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: PARTNERS_UPDATE_PATH,
      element: React.createElement(PartnersAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
